import * as React from "react";
import {resourcesHelper} from "@falcon/services";

interface IProps {
    haveActiveMandate: boolean
    mandate: any;
}

export class DirectDebitDetailsSection extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {

        if (this.props.haveActiveMandate) {
            return (
                <div className="d-flex flex-column justify-content-center mt-3 margin-top-0">
                    <div className="mt-1 mb-2 margin-top-0">
                        <b>Name of account holder: </b>
                        {this.props.mandate.accountName}
                    </div>
                    <div className="mt-1 mb-2 margin-top-0">
                        <b>Account number: </b>
                        {'*****' + this.props.mandate.accountNumber.toString().slice(-3)}
                    </div>
                    <div className="mt-1 mb-2 margin-top-0">
                        <b>Sort code: </b>
                            {`${String(this.props.mandate.sortCode).substring(0, 2)} -
                            ${String(this.props.mandate.sortCode).substring(2, 4)} -
                            ${String(this.props.mandate.sortCode).substring(4, 6)}`}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="warning-banner-dd-details d-flex justify-content-center">
                    <div>
                        <img className="d-block warning-icon" src={`/${resourcesHelper.THEME}/img/alert-grey-blue.svg`} alt="warning-sign"/>
                    </div>
                    <div className="text-left text-red">
                        <p className="mb-0">You no longer have an active Direct Debit with Allianz.</p>
                    </div>
                </div>
            );
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/annual/DirectDebitDetailsSection.tsx